import { Box, Button, Card, Tabs, Typography } from "@mui/material";
import { styled } from "@mui/styles";

export const upimg = "https://i.imgur.com/3LD4CAw.png";
export const bannerImgUrls = ["https://i.imgur.com/TWbUpQ3.jpeg", "https://i.imgur.com/PiNpOT2.jpeg"];
export const PageWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "blue",
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",

  background: "linear-gradient(135deg, #364a65, #4676b7)",
  width: "90%",
  height: "90vh",
  marginLeft: "auto",
  marginRight: "auto",
  // margin: "auto",
  // marginTop: "4%",
}));

export const SliderWrapper = styled(Box)(({ theme }) => ({
  width: "50%",
  //backgroundColor: theme.palette.awasbandhu.primary.main, // Change this to suit the slider
  display: "flex",
  flex: 2,
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  position: "relative",
  padding: "2rem",
}));

export const Slide = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "background-image 1s ease-in-out", // Smooth transitions
}));

export const LoginCard = styled(Card)(({ theme, bgImg }) => ({
  padding: "3rem",
  display: "flex",
  width: "40%",
  position: "relative",
  background: `url('${bgImg}') center center / cover no-repeat`,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: "#fff",
  marginTop: "1rem",
  width: "100%",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)", // Button shadow
  "&:hover": {
    backgroundColor: theme.palette.awasbandhu.primary.dark,
  },
}));

export const EmployeeLoginLink = styled(Typography)(({ theme }) => ({
  color: theme.palette.awasbandhu.primary.main,
  marginTop: "1rem",
  cursor: "pointer",
  textDecoration: "underline",
}));

export const StyledHeading = styled(Typography)({
  textAlign: "center",
  color: "#fff",
  fontSize: "13px",
  fontWeight: 600,
  fontFamily: "sans-serif",
});

export const StyledImage = styled("img")({
  position: "relative",
  width: "18%",
  margin: "0 auto",
  marginTop: "10px",
});

export const ButtonStripWrapper = styled(Box)(() => ({
  display: "flex",
  textAlign: "center",
  height: "40px",
  margin: "10px 25%",
  alignContent: "center",
  width: "fit-content",
}));

export const StyledButtons = styled(Button)(({ theme }) => ({
  backgroundColor: "#325f9d",
  color: "#ffffff",
  width: "150px",
  padding: "10px 30px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)", // Button shadow
  marginLeft: "8px",
  marginRight: "8px",
  transition: "0.3s",
  "&:hover": {
    backgroundColor: theme.palette.awasbandhu.primary.dark,
  },
}));
export const SlideWrapper = styled(Box)(({ theme, bgimg }) => ({
  background: `url('${bgimg}') center center / cover no-repeat`, // Apply dimming effect
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  height: `50%`,
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    height: `60%`,
  },
}));

export const WelcomeSlideText = styled(Box)(({ theme, isVisible }) => ({
  fontSize: "1.5rem",
  fontWeight: "600",
  color: "#fff",
  margin: "auto",
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  fontFamily: '"Raleway", sans-serif',
  display: "flex", // Enable flexbox
  justifyContent: "center", // Horizontally center the text
  alignItems: "center",
  marginTop: "30%",
}));

// Style for the Tabs container
export const ButtonsWrapper = styled(Tabs)(() => ({
  display: "flex", // Flexbox to layout buttons horizontally
  justifyContent: "center", // Center the buttons horizontally
  alignItems: "center", // Align items vertically
  padding: "0.5rem 0", // Add some space around the container
  width: "100%", // Adjust the width of the container
  backgroundColor: "#f5f5f5", // Optional background color for the container
  // Prevent any unwanted styles from Tabs (removes default padding, etc.)
  "& .MuiTabs-flexContainer": {
    width: "100%", // Ensure the flex container takes up the full width
    justifyContent: "center", // Center the buttons within the container
  },
}));
export const Buttons = styled(Tabs)(() => ({
  "&.MuiTab-root": {
    fontSize: ".85rem",
    backgroundColor: "rgb(8, 89, 114)", // Default background color for button
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px", // Rounded corners for button
    margin: "0 5px", // Space between buttons
    textTransform: "none", // Avoid text transformation (uppercase, etc.)
    padding: "10px 20px", // Button padding
    minHeight: "30px", // Set a minimum height for button
    display: "inline-block", // Make buttons appear inline
    cursor: "pointer", // Cursor pointer on hover
    "&:hover": {
      backgroundColor: "rgb(21, 124, 79)", // Hover effect
    },
  },
  "&.Mui-selected": {
    backgroundColor: "rgb(21, 124, 79)", // Selected state background color
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px",
    margin: "0 5px",
    padding: "10px 20px",
    borderBottom: "2px solid #1e8bc5", // Bottom border when selected
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow for selected button
  },
}));
